import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  Input,
  Breadcrumb,
  Button,
  Space,
  Row,
  Popconfirm,
  Tooltip,
} from "antd";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import { ReactComponent as Invoice } from "../../../image/Invoice.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import { debounce } from "lodash";
import { getRequest, postRequest } from "../../../axios";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { DownloadOutlined } from "@ant-design/icons";
import { authUserData } from "../../../utils/Helper";
import moment from "moment";

const CommercialInvoiceList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getCommercialInvoiceList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("commercial-invoice", state);
        console.log('apiResponsecxz', apiResponse);
        
        if (apiResponse.status === 200) {
          setCommercialInvoiceList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_commercial_invoice_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getCommercialInvoiceList();
  }, [state, t, reload]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company__name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company__name";
    }
    if (sortField === "subscription_name" && sortOrder === "ascend") {
      sortingEnumKey = "subscription__package_name";
    }
    if (sortField === "subscription_name" && sortOrder === "descend") {
      sortingEnumKey = "-subscription__package_name";
    }

    if (sortField === "payment_mode" && sortOrder === "ascend") {
      sortingEnumKey = "payment_mode";
    }
    if (sortField === "payment_mode" && sortOrder === "descend") {
      sortingEnumKey = "-payment_mode";
    }

    if (sortField === "payment_reference_id" && sortOrder === "ascend") {
      sortingEnumKey = "payment_reference_id";
    }
    if (sortField === "payment_reference_id" && sortOrder === "descend") {
      sortingEnumKey = "-payment_reference_id";
    }

    if (sortField === "start_date" && sortOrder === "ascend") {
      sortingEnumKey = "start_date";
    }
    if (sortField === "start_date" && sortOrder === "descend") {
      sortingEnumKey = "-start_date";
    }

    if (sortField === "end_date" && sortOrder === "ascend") {
      sortingEnumKey = "end_date";
    }
    if (sortField === "end_date" && sortOrder === "descend") {
      sortingEnumKey = "-end_date";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("commercial-invoice-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg("Commercial Invoice archive successfully");
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg("Error in delete Commercial Invoice");
      }
    } catch (error) {
      ErrorNotificationMsg(error);

    }

  };

  const handleDownload = async (id, companyId) => {
    window.open(
      `commercial-invoice-pdf/${id}`,
      "_blank"
    );
  };


  const columns = [
    {
      title: "Client",
      dataIndex: "billed_to_name",
      key: "billed_to_name",
      sorter: true,
    },
    {
      title: "Invoice No.",
      dataIndex: "invoice_number",
      key: "invoice_number",
      sorter: true,
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      sorter: true,
      render: (date) => {
        return date ? moment(date).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Total (INR)",
      dataIndex: "grand_total",
      key: "grand_total",
      sorter: true,
      render: (value) => value?.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
      }),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => {
          
        return (
        <Space>
          <Link to={"/commercial-invoice/edit/" + btoa(record.id)}>
            {authUserData()?.permission.includes("subcription|change_subscriptioninvoice") && <Editicon />}
          </Link>
              <Tooltip
                      color={colors}
                      placement="right"
                      title={<span style={{ color: "#fff" }}>Archive</span>}
                    >
                      <Popconfirm
                        className="action"
                        title={t("pop_title")}
                        okText={t("pop_ok")}
                        cancelText={t("pop_cancel")}
                        onConfirm={() => handleArchive(record.id)}
                      >
                        {/* {authUserData()?.permission.includes(
                          "request_demo|delete_requestdemo"
                        ) &&  */}
                        <Archive style={{ cursor: "pointer" }} />
                        {/* } */}
                      </Popconfirm>
                    </Tooltip>
          {/* <Invoice /> */}
          <DownloadOutlined  onClick={() => handleDownload(record.id)} />
        </Space>
      )},
    },
  ];
  
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Facilitate smooth international transactions and meet
                  regulatory requirements with our Commercial Invoice.
                </span>
              }
            >
              <h3>{t("commercialInvoiceList")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("commercialInvoiceList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  value={searchText}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchText(value);
                    debounceLoadData(value, onSearch);
                  }}
                  allowClear
                  onSearch={(value) => {
                    setSearchText(value);
                    onSearch(value);
                  }}
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  style={{ width: 250 }}
                />
              </Space>
            </div>
            {authUserData()?.permission.includes(
              "subcription|add_subscriptioninvoice"
            ) && (
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Ensure accurate billing and documentation for international
                    shipments.
                  </span>
                }
              >
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={() => navigate("/commercial-invoice/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("addCommercialInvoice")}
                </Button>
              </Tooltip>
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "subcription|delete_subscriptioninvoice"
                ) && (
                  <ButtonField
                   className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                )}
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/commercial-invoice/archive">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Space>
          {/* {authUserData()?.permission.includes(
              "subcription|add_subscriptioninvoice"
            ) &&
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/commercial-invoice/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("addCommercialInvoice")}
              </Button>
            } */}
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("commercialInvoiceList")}</h1>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                {authUserData()?.permission.includes(
                  "subcription|delete_subscriptioninvoice"
                ) &&
                  <ButtonField
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                }
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/commercial-invoice/archive">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Col> */}
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: "auto",
            }}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={commercialInvoiceList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};

export default CommercialInvoiceList;
